export default __webpack_public_path__ + "static/media/knowMoreCustomer3.b009771d.png";